export default "__VITE_ASSET__CTNlWEy7__"